/* eslint-disable react/prop-types */
import React from 'react';
import { CloseIcon } from '../../../../../src/utils/SVG';
import './index.less';

import SelectInput from '../../../../components/Inputs/newInputs/selectInput/index';
import MoneyInput from '../../../../components/Inputs/newInputs/moneyInput/index';

import { insuranceOptions, insurersList, monthsList } from '../../utils/helpers';

export default function AddReminder({ values, updateValue, closeReminder, index, remindersCount }) {
  return(
    <div className="add-reminder" style={remindersCount > 1 ? { paddingTop: '2.2rem' } : {}}>
      {remindersCount > 1 &&
        <div className="add-reminder-close" onClick={() => closeReminder(index)}>
          <CloseIcon
            fill="#895d85"
          />
        </div>
      }

      {/* Type of insurance */}
      <SelectInput
        value={values.insuranceType}
        setValue={value => updateValue('insuranceType', value)}

        placeholder="Começa a escrever para filtrar"
        title="Tipo de seguro"
        options={insuranceOptions}
        error={_.get(values, 'errors.insuranceType')}
      />

      {/* Insurer */}
      <SelectInput
        value={values.insurer}
        setValue={value => updateValue('insurer', value)}

        placeholder="Começa a escrever para filtrar"
        title="Seguradora"
        options={insurersList}
        error={_.get(values, 'errors.insurer')}
      />

      {/* Renewal Month */}
      <SelectInput
        value={values.renewalMonth}
        setValue={value => updateValue('renewalMonth', value)}

        placeholder="Começa a escrever para filtrar"
        title="Mês de renovação"
        options={monthsList}
        error={_.get(values, 'errors.renewalMonth')}
      />

      {/* Anual Payment */}
      <MoneyInput
        value={values.annualPayment}
        setValue={value => updateValue('annualPayment', value)}

        placeholder="€ 250"
        title="Quanto pagas por ano?"
        note="Ajuda-nos a perceber se podemos encontrar melhor."
        optional
        error={_.get(values, 'errors.annualPayment')}
      />
    </div>
  );
}